export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_USER = "SET_USER";
export const SET_COLLAPSED = "SET_COLLAPSED";
export const SET_TEXT_FILTER = "SET_TEXT_FILTER";
